import {AlertTypeDTO} from 'kashable-mobile-common';

export const alertTitle = (type: AlertTypeDTO.CreditMonitoringAlertType) => {
    return type.replace('_', ' ').toLowerCase();
};
